import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams , useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import { SWAL_SETTINGS, showFilterListByAppointmentStatus, showFilterlistByUser } from "../../../../utils/Constants";
import { capitalizeFirstLetter, formatDateWithTime, formateDateWithMonth, getAppointmentPrice, getAppointmentTypeLabel, handleServerValidations, TrimText } from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import { List } from "../../services/pendingappointment.service";
import { Placeholder, Tooltip, Whisper } from "rsuite";
import { usePermission } from '../../../../utils/commonfunction';

const PendingAppointmentList = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { can } = usePermission();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [searchParams] = useSearchParams();
  const [search, setSearch] = useState({
    ...(searchParams.get("status") ? { status: searchParams.get("status") } : {}),
  });
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Pending Appointments", url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [statusUpdated, setStatusUpdated] = useState(false);

  /********** MULTI SELECT <<<<<<********* */

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData);
  }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno, statusUpdated]);

  const viewFunction = (row) => {
    navigate(`/admin/pending-appointments/view/${row._id}`);
  };

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

  

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Pending Appointments</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                      maxLength={100}
                    />
                  </div>
                </div>

                {/* <div className="me-3">
                  <StatusFilter data={showFilterListByAppointmentStatus} prepareSearch={prepareSearch} selectedStatus={search?.status || ""} />
                </div> */}

                <button type="reset" value="Reset" onClick={resetFilter} className="btn ripple btn-main-primary signbtn ripple">
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>
            {
              loader?
              <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              :
            <>
            <div className="table-responsive min-h-400">
              <table className="table table-bordered card-table border-top text-nowrap w-100">
                <thead>
                  <tr>
                 
                    <th className="position-relative select_head">
                      <span>{t("list_heading_sno")}</span>
                    </th>
                    <th>
                      <span>{t("label_booking_id")}</span>
                    </th>

                  
                    <th>{t("label_user_email")}</th>
                    
                    <th>
                      <span>{t("list_heading_address")}</span>
                    </th>
                    <th className="status_head">Requested Date</th>
                    <th className="status_head">{t("label_booking_date")}</th>
                    <th className="status_head">{t("label_status")}</th>
                    <th className="status_head">Appointment Type</th>
                    <th className="status_head">{t("label_price")}</th>

                    {(can("/admin/pending-appointments/view") || can("/admin/appointments/assign-associate/list")) && (
                      <th className="action_head">Assign</th>
                    )}
                  </tr>
                </thead>
                <tbody>
               
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                              <td>{row?.requestID ? <div className="d-flex">{row?.requestID ? row?.requestID : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>
                              <td>{row?.userData?.email ? row?.userData?.email : "N/A"}</td>
                              

                              <td>{row?.appointmentAddress && row?.appointmentAddress?.address ? TrimText(capitalizeFirstLetter(row?.appointmentAddress?.address, 30)) : "N/A"} </td>

                             {/* <img src="https://static.vecteezy.com/system/resources/thumbnails/057/068/323/small/single-fresh-red-strawberry-on-table-green-background-food-fruit-sweet-macro-juicy-plant-image-photo.jpg"/> */}
                             {/* <img src={row?.prescriptionImage} alt="no issue"/> */}

                              <td>{row?.appointmentDate ? formatDateWithTime(row.createdAt) : "N/A"}</td>

                              <td>{row?.appointmentDate ? formatDateWithTime(row.appointmentDate) : "N/A"}</td>

                              <td>{row?.status ? capitalizeFirstLetter(t(row?.status)) : "N/A"}</td>

                              <td className="text-capitalize">{getAppointmentTypeLabel(row?.appointmentType, row?.appointmentDate)}</td>

                              <td>
                                {getAppointmentPrice(row?.appointmentType, row?.subCategoryData) !== "N/A"
                                  ? `$${getAppointmentPrice(row?.appointmentType, row?.subCategoryData)}`
                                  : "N/A"}
                              </td>

                              {(can("/admin/pending-appointments/view") || can("/admin/appointments/assign-associate/list")) && (
                                <td>
                                  <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                    <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                      {can("/admin/pending-appointments/view") && (
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>View</Tooltip>}>
                                          <button type="button" className="btn view mx-1" onClick={()=>{viewFunction(row)}}>
                                            <i className="ri-eye-fill"></i>
                                          </button>
                                        </Whisper>
                                      )}

                                      {/* {can("/admin/appointments/assign-associate/list") && ( */}
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>Assign Manually</Tooltip>}>
                                          <button type="button" className="btn view" onClick={()=>{navigate(`/admin/appointments/assign-associate/list/${row?._id}/1`)}}>
                                            <i className="ri-pencil-fill"></i>
                                          </button>
                                        </Whisper>
                                      {/* )} */}

                                    </div>

                                    
                                  </div>

                                </td>
                              )}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  
                </tbody>
              </table>
            </div>
            <div className="" id="example1_info" role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Appointment",
                    path: "/admin/pending-appointments/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
            </>}
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingAppointmentList;
